export default __webpack_public_path__ + "static/media/PigPlus.089d680b.png";